import { render, staticRenderFns } from "./ExamModal.vue?vue&type=template&id=6ed8a845&"
import script from "./ExamModal.vue?vue&type=script&lang=js&"
export * from "./ExamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports